import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, BrowserRouter } from 'react-router-dom'
import App from '../components/App'
import Rollbar from 'rollbar/src/browser/rollbar';

const rollbar = Rollbar.init({
  accessToken: '07c139d4e2ab4dd1b1cc2972d68671e6',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: 'production',
  resource: {
     'service.name': 'YOUR_UNIQUE_SERVICE_NAME',
  },
  recorder: {
    enabled: true,
    autoStart: true,
    // ...privacy options below
  }

});
// Make global if needed
window.rollbar = rollbar;

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
    document.body.appendChild(document.createElement('div')),
  )
})
